import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { US_STATES } from './usStates';

interface StateFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
}

const StateFilter: React.FC<StateFilterProps> = ({ value, onChange }) => {
  return (
    <div>
      <Dropdown
        placeholder="All states"
        fluid
        multiple
        search
        selection
        clearable
        options={US_STATES}
        value={value}
        onChange={(_, { value: v }) => onChange((v as string[]) || [])}
        style={{ minWidth: '200px' }}
      />
    </div>
  );
};

export default StateFilter;
